module.exports = __webpack_public_path__ + "img/icon.6ca8448c.png";